var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSignupCheckOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.75H16C16.4641 0.75 16.9091 0.934507 17.2373 1.2627C17.5655 1.59088 17.75 2.03587 17.75 2.5V16.5C17.75 16.9641 17.5655 17.4091 17.2373 17.7373C16.9091 18.0655 16.4641 18.25 16 18.25H2C1.53587 18.25 1.09088 18.0655 0.762695 17.7373C0.434507 17.4091 0.25 16.9641 0.25 16.5V2.5C0.25 2.03587 0.434507 1.59088 0.762695 1.2627C1.09088 0.934507 1.53587 0.75 2 0.75Z",
    stroke: "#555555",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSignupCheckOff);
export default __webpack_public_path__ + "static/media/btn_signup_check_off.cb3c43f83ece72da08999250b57d0513.svg";
export { ForwardRef as ReactComponent };